import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, ShoppingCart, Flame } from 'lucide-react';
export function UrgencyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [showPurchase, setShowPurchase] = useState(false);
  useEffect(() => {
    let observer: IntersectionObserver | undefined;
    const observePricing = () => {
      const pricingSection = document.getElementById('pricing');
      if (!pricingSection || !('IntersectionObserver' in window)) return false;
      observer = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting), {
        rootMargin: '0px 0px -45% 0px'
      });
      observer.observe(pricingSection);
      return true;
    };
    if (observePricing()) return () => observer?.disconnect();
    const mutationObserver = new MutationObserver(() => {
      if (!observePricing()) return;
      mutationObserver.disconnect();
    });
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => {
      observer?.disconnect();
      mutationObserver.disconnect();
    };
  }, []);
  useEffect(() => {
    if (!isVisible) {
      setShowPurchase(false);
      return;
    }
    const showTimer = window.setTimeout(() => setShowPurchase(true), 4000);
    const hideTimer = window.setTimeout(() => setShowPurchase(false), 9000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-307" data-mp="2fn54vkti983f">
      {isVisible && <motion.div initial={{
      y: -32,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -32,
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="pointer-events-none fixed left-0 right-0 top-12 z-[65] flex flex-col items-center px-4" data-id="element-308" data-mp="2fkspnff4tbu2">
          <div className="pointer-events-auto flex max-w-fit flex-col gap-1 rounded-[24px] border border-gray-100 bg-white px-6 py-2 shadow-xl" data-id="element-309" data-mp="qa1pdfupbl6f">
            <div className="flex items-center gap-3 text-[10px] font-black uppercase tracking-wide text-[#4c1d95] md:text-[11px]" data-id="element-310" data-mp="2wwh6vd580iqa">
              <div className="h-2 w-2 rounded-full bg-[#22c55e] shadow-[0_0_8px_rgba(34,197,94,0.6)]" data-id="element-311" data-mp="2rxmogcb60w6p" />
              <Users className="h-3.5 w-3.5" data-id="element-312" data-mp="2n4l77xnhkkjy" />
              <span data-id="element-313" data-mp="2i7urjbflfqz2">27 personas mirando</span>
            </div>
            <div className="flex items-center gap-3 text-[10px] font-black uppercase tracking-wide text-[#4c1d95] md:text-[11px]" data-id="element-314" data-mp="2i58j79kvp7fs">
              <div className="h-2 w-2 rounded-full bg-[#ef4444] shadow-[0_0_8px_rgba(239,68,68,0.6)]" data-id="element-315" data-mp="296wk0j5y51bq" />
              <Flame className="h-3.5 w-3.5" data-id="element-316" data-mp="2470fmitc77vn" />
              <span data-id="element-317" data-mp="247sd5z6hvfok">Cupos disponibles: 7</span>
            </div>
          </div>

          <AnimatePresence data-id="element-318" data-mp="1z9quhfczdidm">
            {showPurchase && <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: -8
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: -8
        }} transition={{
          duration: 0.2
        }} className="pointer-events-auto mt-2 w-full max-w-[300px]" data-id="element-319" data-mp="2fx31nzvzj8g">
                <div className="flex items-center justify-center gap-2 rounded-full bg-[#16a34a] px-5 py-2 text-[10px] font-black uppercase tracking-wider text-white shadow-[0_4px_15px_rgba(22,163,74,0.3)]" data-id="element-320" data-mp="9ydf16vbq4s1">
                  <ShoppingCart className="h-3.5 w-3.5" data-id="element-321" data-mp="jozqqpzx6b5g" />
                  <span data-id="element-322" data-mp="3j54o2a1nmqsm">¡Alguien acaba de comprar!</span>
                </div>
              </motion.div>}
          </AnimatePresence>
        </motion.div>}
    </AnimatePresence>;
}